import { lazy } from 'react';

export const CourseList = lazy(() => import('./course/CourseList'));
export const AddCourse = lazy(() => import('./course/AddCourse'));
export const UpdateCourse = lazy(() => import('./course/UpdateCourse'));
export const CountryList = lazy(() => import('./country/CountryList'));
export const CityList = lazy(() => import('./city/CityList'));
export const DistrictList = lazy(() => import('./district/DistrictList'));
export const StateList = lazy(() => import('./state/StateList'));
export const TehsilList = lazy(() => import('./tehsil/TehsilList'));
export const SessionList = lazy(() => import('./session/SessionList'));
export const SemesterList = lazy(() => import('./semester/SemesterList'));
export const StudentList = lazy(() => import('./student/StudentList'));
export const AddStudent = lazy(() => import('./student/AddStudent'));
export const UpdateStudent = lazy(() => import('./student/UpdateStudent'));
export const StudentDetails = lazy(() => import('./student/StudentDetails'));
export const SubjectList = lazy(() => import('./subject/SubjectList'));
export const DesignationList = lazy(() => import('./designation/DesignationList'));
export const DepartmentList = lazy(() => import('./department/DepartmentList'));
export const SlotList = lazy(() => import('./slot/SlotList'));
export const AddSlot = lazy(() => import('./slot/AddSlot'));
export const UpdateSlot = lazy(() => import('./slot/UpdateSlot'));
export const MasterPaymentList = lazy(() => import('./payment/MasterPaymentList'));
export const StaffList = lazy(() => import('./staff/StaffList'));
export const AddStaff = lazy(() => import('./staff/AddStaff'));
export const UpdateStaff = lazy(() => import('./staff/UpdateStaff'));
export const CouponList = lazy(() => import('./coupon/CouponList'));
export const CouponDetails = lazy(() => import('./coupon/CouponDetails'));
export const TopicList = lazy(() => import('./topic/TopicList'));
export const AddTopic = lazy(() => import('./topic/AddTopic'));
export const UpdateTopic = lazy(() => import('./topic/UpdateTopic'));
